import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle, Phone } from "lucide-react";
import { LOGO_URL, MAPS_URL, track, whatsappLink } from "../lib/site";
import { useSite } from "../context/SiteContext";

export const Footer = () => {
  const { openBooking, settings } = useSite();
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="footer-cta">
        <span className="eyebrow light">Reservations open daily, 8 AM – 10 PM</span>
        <h2>Come away<br /><em>to yourself.</em></h2>
        <div className="footer-cta-buttons">
          <button className="gold-button" onClick={() => { track("book_now_click", { location: "footer" }); openBooking({}); }} data-testid="footer-book-button">
            Book your stay <ArrowUpRight size={16} />
          </button>
          <a
            className="text-link light-link"
            href={whatsappLink("Hello Madhubhan Resort & Spa, I would like to enquire about a stay.", settings.whatsapp)}
            target="_blank"
            rel="noreferrer"
            onClick={() => track("whatsapp_click", { location: "footer" })}
            data-testid="footer-whatsapp-link"
          >
            <MessageCircle size={16} /> WhatsApp us
          </a>
          <a className="text-link light-link" href={`tel:${settings.phone_tel}`} onClick={() => track("call_click", { location: "footer" })} data-testid="footer-call-link">
            <Phone size={16} /> {settings.phone_display}
          </a>
        </div>
      </div>
      <div className="footer-grid">
        <div className="footer-brand">
          <img className="brand-logo footer-logo" src={LOGO_URL} alt="Madhubhan Resort & Spa" />
          <p>{settings.hotel_description || "An ethno-modern sanctuary on the Anand–Sojitra Road, Gujarat."}</p>
        </div>
        <div className="footer-col">
          <span>Explore</span>
          <Link to="/rooms" data-testid="footer-link-rooms">Rooms & Suites</Link>
          <Link to="/spa" data-testid="footer-link-spa">Resort & Spa</Link>
          <Link to="/dining" data-testid="footer-link-dining">Dining</Link>
          <Link to="/experiences" data-testid="footer-link-experiences">Experiences</Link>
          <Link to="/gallery" data-testid="footer-link-gallery">Gallery</Link>
        </div>
        <div className="footer-col">
          <span>Plan</span>
          <Link to="/offers" data-testid="footer-link-offers">Offers & Packages</Link>
          <Link to="/about" data-testid="footer-link-about">About Us</Link>
          <Link to="/contact" data-testid="footer-link-contact">Contact Us</Link>
          <Link to="/policies" data-testid="footer-link-policies">Terms & Cancellation</Link>
          <Link to="/privacy" data-testid="footer-link-privacy">Privacy Policy</Link>
          <a href={MAPS_URL} target="_blank" rel="noreferrer" data-testid="footer-link-maps">Find us on Maps</a>
        </div>
        <div className="footer-col">
          <span>Reservations</span>
          <a href={`tel:${settings.phone_tel}`} onClick={() => track("call_click", { location: "footer_contact" })} data-testid="footer-phone">{settings.phone_display}</a>
          <a href={`mailto:${settings.email}`} data-testid="footer-email">{settings.email}</a>
          <p className="footer-address" data-testid="footer-address">{settings.address}</p>
        </div>
      </div>
      <div className="footer-bar">
        <span>© 2026 Madhubhan Resort & Spa</span>
        <span><Link to="/policies" data-testid="footer-bar-policies">Terms & Cancellation</Link> · <Link to="/privacy" data-testid="footer-bar-privacy">Privacy Policy</Link></span>
      </div>
    </footer>
  );
};
